import { checkTrackingConversion } from './helpers/util';

// Sellers enter the Conversion ID with or without the "AW-" prefix.
function normalizeConversionId(id) {
  return String(id || '').trim().replace(/^AW-/i, '');
}

/**
 * @param {object} [conversion] - { transaction_id, value, currency } of a placed order. Only pages that pass it
 *   (the success page) report a Google Ads conversion; the others only load the tag.
 */
export async function handleGoogleAdsTracking(trackingGA, scripts, globalConversionSetting, conversionScope, conversion) {
  for (const ga of trackingGA) {
    const conversionId = normalizeConversionId(ga.pixelId);
    if (!conversionId) continue;

    const shouldProcess = await checkTrackingConversion(
      ga,
      `pixelsGoogleAds_${ga.pixelId}`,
      globalConversionSetting,
      conversionScope
    );
    if (!shouldProcess) continue;

    scripts.push({
      script: `<script defer src='https://www.googletagmanager.com/gtag/js?id=AW-${conversionId}'></script>`,
      name: "GTA",
      type: "GTA"
    });

    scripts.push({
      script: `<script>window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date()); gtag('config', 'AW-${conversionId}');</script>`,
      name: "GTA",
      type: "GTA"
    });

    // name holds the Conversion Label; it defaults to the Conversion ID until the seller sets a label.
    const label = String(ga.name || '').trim();
    if (conversion && conversion.transaction_id && label && normalizeConversionId(label) !== conversionId) {
      const params = JSON.stringify({
        send_to: `AW-${conversionId}/${label}`,
        transaction_id: String(conversion.transaction_id),
        value: Number(conversion.value) || 0,
        currency: conversion.currency || 'IDR'
      }).replace(/</g, '\\u003c');

      scripts.push({
        script: `<script>gtag('event', 'conversion', ${params});</script>`,
        name: "GTA",
        type: "GTA"
      });
    }
  }
}
